import React from "react";

const FieldError = props => (
    <div>
        <span className="alert-label">This is a required field</span>
    </div>
);

export default class SingleInput extends React.Component {
    render() {
        return (
            <div>
                <label htmlFor={this.props.name}>{this.props.label}</label>
                {this.props.error ? <FieldError /> : null}
                <div
                    className={
                        this.props.error ? "prepend alert-input" : "prepend"
                    }
                >
                    <span className="prepend-item">
                        <i className={this.props.icon} />
                    </span>
                    <input
                        id={this.props.name}
                        type={this.props.inputType}
                        className="prepend-field ensightencustomevent"
                        data-label={
                            this.props.label // Analytics Label
                        }
                        autoComplete={this.props.autoComplete}
                        value={this.props.value}
                        onChange={this.props.controlFunc}
                        autoCapitalize="off"
                        autoCorrect="off"
                    />
                </div>
            </div>
        );
    }
}
